<template>
  <section class="success-academy">
    <div class="success-academy__banner">
      <TopBanner :item="banner" />
    </div>
    <div class="_bg-light">
      <div class="container _py-16 _mb-16 _mb-sm-12 _py-sm-12">
        <!-- <h1
          class="success-academy__title _fs-48 _fs-sm-32 _lh-sm-38 _lh-54 _fw-700 _mb-4"
        >
          {{ $t('pages.success_academy.main_title') }}
        </h1>

        <h2
          class="success-academy__subtitle _fs-30 _fs-sm-24 _lh-sm-32 _lh-42 _fw-5 00 _mb-12"
          v-html="$t('pages.success_academy.main_subtitle')"
        ></h2> -->

        <section
          class="_fs-24 _fs-sm-20 _lh-sm-24 lh-32 _tc-dark _fw-700 _mb-8 d-flex justify-center"
        >
          {{ $t("pages.success_academy.group") }}
        </section>

        <div
          class="d-grid row-1-1 gap-32"
          v-if="getAcademyList && Object.keys(this.getAcademyList).length"
        >
          <SectionCard
            v-if="marketing && Object.keys(marketing).length"
            @click.native="
              dataLayerPush(
                marketing.translates[0].title,
                helpers.buildRoute({
                  name: 'SuccessAcademySections',
                  params: { slug: marketing.slug },
                })
              )
            "
            :item="marketing"
            class="card_broken"
          >
            <template v-slot:image>
              <img :src="marketing.translates[0].preview" alt="" />
            </template>

            <template v-slot:title>
              <div
                class="_fs-24 _lh-32 d-none d-xl-block"
                v-html="marketing.translates[0].title"
              ></div>
              <div
                class="d-lg-none"
                v-html="marketing.translates[0].title"
              ></div>
            </template>
            <template v-slot:button>
              <AppBtn :btnClass="'btn_orange'" class="d-none d-xl-grid">
                <span class="_tc-white _fs-16 _py-2 _px-3">{{
                  $t("interface.more")
                }}</span>
              </AppBtn>
            </template>
          </SectionCard>
          <SectionCard
            v-if="products && Object.keys(products).length"
            @click.native="
              dataLayerPush(
                products.translates[0].title,
                helpers.buildRoute({
                  name: 'SuccessAcademySections',
                  params: { slug: products.slug },
                })
              )
            "
            :item="products"
            class="card_broken"
          >
            <template v-slot:image>
              <img :src="products.translates[0].preview" alt="" />
            </template>

            <template v-slot:title>
              <div
                class="_fs-24 _lh-32 d-none d-xl-block"
                v-html="products.translates[0].title"
              ></div>
              <div
                class="d-lg-none"
                v-html="products.translates[0].title"
              ></div>
            </template>
            <template v-slot:button>
              <AppBtn :btnClass="'btn_orange'" class="d-none d-xl-grid">
                <span class="_tc-white _fs-16 _py-2 _px-3">{{
                  $t("interface.more")
                }}</span>
              </AppBtn>
            </template>
          </SectionCard>
          <SectionCard
            v-if="dependsOnMe && Object.keys(dependsOnMe).length"
            @click.native="
              dataLayerPush(
                dependsOnMe.translates[0].title,
                helpers.buildRoute({
                  name: 'SuccessAcademySections',
                  params: { slug: dependsOnMe.slug },
                })
              )
            "
            :item="dependsOnMe"
            class="card_large"
          >
            <template v-slot:image>
              <img :src="dependsOnMe.translates[0].preview" alt="" />
            </template>

            <template v-slot:title>
              <div
                class="_tc-white _fs-32 _lh-38 d-none d-xl-block"
                v-html="dependsOnMe.translates[0].title"
              ></div>
              <div
                class="d-lg-none"
                v-html="dependsOnMe.translates[0].title"
              ></div>
            </template>
            <template v-slot:button>
              <AppBtn :btnClass="'btn_orange'" class="d-none d-xl-grid">
                <span class="_tc-white _fs-16 _py-3 _px-4">{{
                  $t("interface.more")
                }}</span>
              </AppBtn>
            </template>
          </SectionCard>
        </div>
      </div>
    </div>
    <div>
      <div class="container">
        <h2
          class="success-academy__title _fs-48 _lh-54 _fw-700 _mb-8 _fs-sm-32 _lh-sm-38"
          v-html="$t('pages.success_academy.second_title')"
        ></h2>
        <div class="d-grid row-1-1 gap-32">
          <SectionCard
            v-if="history && Object.keys(history).length"
            @click.native="
              blockClick(
                history.translates[0].title,
                helpers.buildRoute({
                  name: 'SuccessAcademySections',
                  params: { slug: history.slug },
                })
              )
            "
            :item="history"
          >
            <template v-slot:image>
              <img :src="history.translates[0].preview" alt="" />
            </template>

            <template v-slot:title>
              <div v-html="history.translates[0].title"></div>
            </template>
            <template v-slot:description>
              <div v-html="history.translates[0].description"></div>
            </template>
          </SectionCard>
          <SectionCard
            v-if="businessPotok && Object.keys(businessPotok).length"
            @click.native="
              blockClick(
                businessPotok.translates[0].title,
                helpers.buildRoute({
                  name: 'SuccessAcademySections',
                  params: { slug: businessPotok.slug },
                })
              )
            "
            :item="businessPotok"
          >
            <template v-slot:image>
              <img :src="businessPotok.translates[0].preview" alt="" />
            </template>

            <template v-slot:title>
              <div v-html="businessPotok.translates[0].title"></div>
            </template>
            <template v-slot:description>
              <div v-html="businessPotok.translates[0].description"></div>
            </template>
          </SectionCard>
          <SectionCard
            v-if="achievements && Object.keys(achievements).length"
            @click.native="
              blockClick(
                achievements.translates[0].title,
                helpers.buildRoute({
                  name: 'SuccessAcademySections',
                  params: { slug: achievements.slug },
                })
              )
            "
            :item="achievements"
          >
            <template v-slot:image>
              <img :src="achievements.translates[0].preview" alt="" />
            </template>

            <template v-slot:title>
              <div v-html="achievements.translates[0].title"></div>
            </template>
            <template v-slot:description>
              <div v-html="achievements.translates[0].description"></div>
            </template>
          </SectionCard>
          <SectionCard
            v-if="consultant && Object.keys(consultant).length"
            @click.native="
              blockClick(
                consultant.translates[0].title,
                helpers.buildRoute({
                  name: 'SuccessAcademySections',
                  params: { slug: consultant.slug },
                })
              )
            "
            :item="consultant"
          >
            <template v-slot:image>
              <img :src="consultant.translates[0].preview" alt="" />
            </template>

            <template v-slot:title>
              <div v-html="consultant.translates[0].title"></div>
            </template>
            <template v-slot:description>
              <div v-html="consultant.translates[0].description"></div>
            </template>
          </SectionCard>
        </div>
        <div class="_fs-24 _lh-32 _tc-grey _mb-6 _mt-12 _px-sm-4" v-if="false">
          {{ $t("pages.success_academy.certificate.head") }}
        </div>
        <div class="_px-md-4" v-if="false">
          <div
            class="certificate _mb-16 _mb-sm-12 _px-md-6 _py-md-8 _px-16 _py-8"
          >
            <picture>
              <source
                :srcset="
                  require('@/assets/img/success-academy/academy-cert-375.jpg')
                "
                media="(max-width: 743px)"
              />
              <source
                :srcset="
                  require('@/assets/img/success-academy/academy-cert-768.jpg')
                "
                media="(max-width: 1220px)"
              />
              <source
                :srcset="
                  require('@/assets/img/success-academy/academy-cert-1920.jpg')
                "
                media="(min-width: 1280px)"
              />
              <img
                class="certificate__img"
                :src="
                  require('@/assets/img/success-academy/academy-cert-1920.jpg')
                "
              />
            </picture>
            <div
              class="certificate__caption _mr-8 _mr-md-0 _mb-md-4 _fs-24 _fs-sm-20 _lh-sm-24 _lh-32 tc-dark _fw-600"
            >
              {{ $t("pages.success_academy.certificate.title") }}
            </div>
            <div class="certificate__description">
              <span class="_fs-16 _lh-24 _tc-dark-grey">{{
                $t("pages.success_academy.certificate.descr")
              }}</span>
              <AppBtn
                @click.native="showCertModal(true, certData)"
                :btnClass="'btn_orange'"
                class="_mt-4"
                ><span class="_tc-white _fs-18 _py-2 _px-3">{{
                  $t("pages.success_academy.certificate.btn")
                }}</span></AppBtn
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AppBtn from "@/components/UI/buttons/AppBtn";
import SectionCard from "@/components/UI/cards/SectionCard";
import TopBanner from "@/components/UI/banners/TopBanner";
import { mapActions, mapGetters } from "vuex";
import toPage from "@/mixins/toPage";
import { bus } from "@/main";

export default {
  metaInfo() {
    return { title: this.$t("pages.success_academy.main_title") };
  },
  name: "SuccessAcademy",
  components: {
    AppBtn,
    SectionCard,
    TopBanner,
  },
  mixins: [toPage],
  data: () => ({}),
  computed: {
    ...mapGetters(["getAcademyList"]),
    marketing() {
      return this.getAcademyList.find((el) => el.slug === "marketing-plan");
    },
    products() {
      return this.getAcademyList.find((el) => el.slug === "our-products");
    },
    dependsOnMe() {
      return this.getAcademyList.find(
        (el) => el.slug === "I-it-all-depends-on-me"
      );
    },
    history() {
      return this.getAcademyList.find(
        (el) => el.slug === "company-history-philosophy-and-heritage"
      );
    },
    consultant() {
      return this.getAcademyList.find(
        (el) => el.slug === "business-development"
      );
    },
    achievements() {
      return this.getAcademyList.find(
        (el) =>
          el.slug ===
          "dostizheniya-v-ispolzovanii-produkta-i-v-postroenii-biznesa"
      );
    },
    businessPotok() {
      return this.getAcademyList.find((el) => el.slug === "biznes-potok");
    },
    certData() {
      return {
        name: this.$t("pages.success_academy.main_title"),
        slug: "academy_success",
        color: "emerald",
      };
    },
    banner() {
      return {
        title: this.$t("pages.success_academy.main_title"),
        descr: this.$t("pages.success_academy.main_subtitle"),
        images: [
          {
            src: require("@/assets/img/banners/success-academy/SA-mob.jpg"),
            media: "(max-width: 540px)",
          },
          {
            src: require("@/assets/img/banners/success-academy/SA-tab.jpg"),
            media: "(max-width: 1024px)",
          },
          {
            src: require("@/assets/img/banners/success-academy/SA-1440.jpg"),
            media: "(max-width: 1440px)",
          },
          {
            src: require("@/assets/img/banners/success-academy/SA-1920.jpg"),
            media: "(min-width: 1441px)",
          },
        ],
      };
    },
  },
  methods: {
    ...mapActions(["fetchAcademyList"]),
    showCertModal(state, intensive) {
      bus.$emit("showCertModal", state, intensive);
      if (this.$gtm) {
        this.$gtm.push({
          event: "academy_sertificat",
          param_value: this.helpers.stripHtml(
            this.$t("pages.success_academy.main_title")
          ),
        });
      }
    },
    dataLayerPush(txt, path) {
      if (this.$gtm) {
        this.$gtm.push({
          event: "academy_module",
          param_value: this.helpers.stripHtml(txt),
        });
      }

      this.toPage(path);
    },
    blockClick(txt, path) {
      if (this.$gtm) {
        this.$gtm.push({
          event: "academy_block",
          param_value: this.helpers.stripHtml(txt),
        });
      }

      this.toPage(path);
    },
  },
  async mounted() {
    await this.fetchAcademyList(this.Trans.currentLocale);
  },
};
</script>

<style lang="scss" scoped>
.success-academy {
  &__title {
    color: color(dark);
    text-align: center;
  }

  &__subtitle {
    color: color(dark-grey);
    text-align: center;
  }

  &__banner {
    background-color: #eef3f7;
  }

  .top-banner {
    max-width: 1920px;
    margin: 0 auto;
  }
}

.certificate {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  height: 190px;
  position: relative;
  border-radius: 16px;
  border: 1px solid color(grey-second);
  overflow: hidden;

  @media screen and (max-width: 1220px) {
    height: auto;
    flex-direction: column;
    padding-bottom: 380px !important;
  }

  @media screen and (max-width: 743px) {
    height: auto;
    flex-direction: column;
    padding-bottom: 200px !important;
  }

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: bottom right;

    @media screen and (max-width: 1220px) {
      object-position: bottom center;
    }
  }

  &__caption {
    position: relative;
    z-index: 2;
    max-width: 320px;

    @media screen and (max-width: 1220px) {
      max-width: none;
    }
  }

  &__description {
    position: relative;
    z-index: 2;
    max-width: 531px;
    @media screen and (max-width: 1220px) {
      max-width: none;
    }
  }
}

.row-1-1 {
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 1220px) {
    grid-template-columns: 1fr;
  }
}
.gap-32 {
  grid-gap: 32px;
}
</style>
